import { Box } from '@chakra-ui/react'
import { FC } from 'react'

const MarkdownTd: FC = (props) => {
  return <Box as="td" p="4" border="1px solid" borderColor="gray.100" {...props} />
}

export default MarkdownTd
